// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"8b311ad7","242":"c4821db1","453":"d78093b3","482":"94c06630"}[chunkId] + ".chunk.js";
};